/* NK section pack script */
/* NK Theme — theme.js (no dependencies) */
(() => {
  'use strict';
  const T = window.nkTheme || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const debounce = (fn, ms = 250) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || '£{{amount}}';
    const m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return format;
    const fmt = (n, p = 2, t = ',', d = '.') => {
      if (isNaN(n) || n == null) return 0;
      const s = (n / 100).toFixed(p).split('.');
      return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (s[1] ? d + s[1] : '');
    };
    let v;
    switch (m[1]) {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(m[0], v);
  }
  T.formatMoney = formatMoney;

  /* ---------- Toast ---------- */
  function toast(msg) {
    const el = $('[data-nk-toast]'); if (!el) return;
    el.textContent = msg; el.classList.add('nk-is-visible');
    clearTimeout(el._t); el._t = setTimeout(() => el.classList.remove('nk-is-visible'), 2600);
  }
  T.toast = toast;

  /* ---------- Drawers ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('nk-is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const f = d.querySelector('[data-nk-autofocus], input, button, a'); if (f) setTimeout(() => f.focus({ preventScroll: true }), 50);
  }
  function closeDrawer(d) {
    if (typeof d === 'string') d = document.getElementById(d);
    if (!d) return;
    d.classList.remove('nk-is-open'); d.setAttribute('aria-hidden', 'true');
    if (!$('.nk-drawer.is-open, .nk-modal.is-open')) document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }
  T.openDrawer = openDrawer; T.closeDrawer = closeDrawer;

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-nk-drawer-open]');
    if (opener) {
      const id = opener.getAttribute('data-nk-drawer-open');
      if (id === 'CartDrawer' && T.cartType !== 'drawer') return;
      e.preventDefault(); openDrawer(id); return;
    }
    const closer = e.target.closest('[data-nk-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.nk-drawer, .nk-modal')); return; }
    const modalOpen = e.target.closest('[data-nk-modal-open]');
    if (modalOpen) { e.preventDefault(); const m = document.getElementById(modalOpen.getAttribute('data-nk-modal-open')); if (m) { lastFocus = modalOpen; m.classList.add('nk-is-open'); document.body.style.overflow = 'hidden'; const zt = modalOpen.getAttribute('data-nk-zoom-target'); if (zt) { const z = document.getElementById(zt); if (z) setTimeout(() => z.scrollIntoView({ block: 'start' }), 30); } } return; }
    // close open header dropdowns when clicking outside
    $$('.nk-header details[open]').forEach((det) => { if (!det.contains(e.target)) det.removeAttribute('open'); });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.nk-drawer.is-open, .nk-modal.is-open').forEach((d) => closeDrawer(d));
    $$('.nk-header details[open]').forEach((d) => d.removeAttribute('open'));
    const s = $('[data-nk-search-modal]:not([hidden])'); if (s) s.hidden = true;
  });

  /* ---------- Cart ---------- */
  const Cart = {
    async refresh(openAfter = false) {
      try {
        const sectionIds = ['cart-drawer'];
        $$('[data-nk-cart-section]').forEach((el) => sectionIds.push(el.getAttribute('data-nk-cart-section')));
        const [cart, sections] = await Promise.all([
          fetch(T.routes.root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()),
          fetch(`${T.routes.root}?sections=${[...new Set(sectionIds)].join(',')}`).then((r) => r.json())
        ]);
        this.render(sections);
        $$('[data-nk-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        if (openAfter) openDrawer('CartDrawer');
        return cart;
      } catch (err) { console.error(err); }
    },
    render(sections) {
      if (!sections) return;
      Object.keys(sections).forEach((id) => {
        if (!sections[id]) return;
        const html = new DOMParser().parseFromString(sections[id], 'text/html');
        const targets = id === 'cart-drawer' ? [['[data-nk-cart-drawer-inner]', '[data-nk-cart-drawer-inner]']] : [[`[data-nk-cart-section="${id}"]`, `[data-nk-cart-section="${id}"]`]];
        targets.forEach(([sel, src]) => {
          const target = $(sel), source = html.querySelector(src);
          if (target && source) target.innerHTML = source.innerHTML;
        });
      });
      initAll(document.getElementById('CartDrawer') || document);
      $$('[data-nk-cart-section]').forEach((s) => initAll(s));
    },
    async change(line, quantity) {
      const res = await fetch(T.routes.cartChange + '.js', { method: 'POST', headers: jsonHeaders, body: JSON.stringify({ line, quantity }) });
      const data = await res.json();
      if (!res.ok || data.status) toast(data.description || data.message || T.strings.cartError);
      return this.refresh();
    },
    async update(body) {
      const res = await fetch(T.routes.cartUpdate + '.js', { method: 'POST', headers: jsonHeaders, body: JSON.stringify(body) });
      const data = await res.json();
      return { ok: res.ok, data };
    },
    async add(items) {
      const res = await fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: jsonHeaders, body: JSON.stringify({ items }) });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.cartError);
      return data;
    }
  };
  T.cart = Cart;

  function initShipBars(root) {
    $$('[data-nk-ship-bar]', root).forEach((bar) => {
      const rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
      if (rate === 1) return;
      const threshold = Math.round(parseInt(bar.dataset.nkThreshold, 10) * rate);
      const total = parseInt(bar.dataset.nkTotal, 10) || 0;
      const remaining = Math.max(0, threshold - total);
      const txt = bar.querySelector('[data-nk-ship-text]'); const fill = bar.querySelector('[data-nk-ship-fill]');
      if (txt) txt.textContent = remaining > 0 ? bar.dataset.nkText.replace('[amount]', formatMoney(remaining)) : bar.dataset.nkSuccess;
      if (fill) fill.style.width = Math.min(100, (total * 100) / threshold) + '%';
    });
  }

  function initCartControls(root) {
    initShipBars(root);
    $$('[data-nk-cart-line]', root).forEach((row) => {
      if (row._init) return; row._init = true;
      const line = parseInt(row.getAttribute('data-nk-cart-line'), 10);
      const input = row.querySelector('input[type="number"]');
      const commit = debounce(() => { row.style.opacity = '.5'; Cart.change(line, parseInt(input.value, 10) || 0); }, 400);
      row.addEventListener('click', (e) => {
        const b = e.target.closest('[data-nk-qty]');
        if (b && input) { e.preventDefault(); input.value = Math.max(0, (parseInt(input.value, 10) || 0) + (b.dataset.nkQty === 'plus' ? 1 : -1)); commit(); }
        if (e.target.closest('[data-nk-cart-remove]')) { e.preventDefault(); row.style.opacity = '.5'; Cart.change(line, 0); }
      });
      if (input) input.addEventListener('change', commit);
    });
    $$('[data-nk-cart-note]', root).forEach((ta) => {
      if (ta._init) return; ta._init = true;
      ta.addEventListener('input', debounce(() => Cart.update({ note: ta.value }), 500));
    });
    $$('[data-nk-discount-form]', root).forEach((form) => {
      if (form._init) return; form._init = true;
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const input = form.querySelector('input'); const err = form.parentElement.querySelector('[data-nk-discount-error]');
        const code = (input.value || '').trim();
        if (!code) { if (err) { err.hidden = false; } return; }
        if (err) err.hidden = true;
        const btn = form.querySelector('button'); btn.classList.add('nk-loading');
        const existing = JSON.parse(form.getAttribute('data-nk-existing') || '[]');
        const codes = [...new Set([...existing, code])].join(',');
        await Cart.update({ discount: codes });
        btn.classList.remove('nk-loading');
        Cart.refresh();
      });
    });
    $$('[data-nk-discount-remove]', root).forEach((b) => {
      if (b._init) return; b._init = true;
      b.addEventListener('click', async (e) => {
        e.preventDefault();
        const form = $('[data-nk-discount-form]');
        const existing = JSON.parse((form && form.getAttribute('data-nk-existing')) || '[]').filter((c) => c !== b.dataset.nkDiscountRemove);
        await Cart.update({ discount: existing.join(',') });
        Cart.refresh();
      });
    });
  }

  /* ---------- Atlas cart drawer bridge ---------- */
  async function openAtlasCart() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function' || T.cartType !== 'drawer') { window.location.href = T.routes.cart; return; }
    try {
      const ids = drawer.getSectionsToRender().filter(Boolean).map((s) => s.id);
      const [sections, cart] = await Promise.all([
        fetch(`${T.routes.root}?sections=${[...new Set(ids)].join(',')}`).then((r) => r.json()),
        fetch(T.routes.root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json())
      ]);
      drawer.classList.toggle('is-empty', !cart.item_count);
      drawer.renderContents({ id: cart.items && cart.items[0] ? cart.items[0].variant_id : null, sections });
      document.dispatchEvent(new CustomEvent('nk:cart:updated', { detail: { cart } }));
    } catch (e) { window.location.href = T.routes.cart; }
  }

  /* ---------- Product form ---------- */
  function initProductForms(root) {
    $$('form[data-nk-product-form]', root).forEach((form) => {
      if (form._init) return; form._init = true;
      form.addEventListener('submit', async (e) => {
        // Page-cart mode: let simple forms submit natively; multi-line bundles and buy-now still go via ajax
        const buyNow = form.hasAttribute('data-nk-skip-cart') || (e.submitter && e.submitter.hasAttribute('data-nk-buy-now'));
        if (T.cartType !== 'drawer' && !form._multi && !buyNow && !form.hasAttribute('data-nk-ajax-always')) return;
        e.preventDefault();
        const btn = e.submitter || form.querySelector('[type="submit"]') || (form.id && document.querySelector(`[form="${form.id}"][type="submit"]`));
        const errorBox = (form.closest('[data-nk-product-root]') || form.parentElement).querySelector('[data-nk-form-error]');
        if (btn) { btn.classList.add('nk-loading'); btn.setAttribute('aria-disabled', 'true'); }
        if (errorBox) errorBox.hidden = true;
        try {
          const items = buildItems(form);
          await Cart.add(items);
          if (buyNow) { window.location.href = T.routes.root + 'checkout'; return; }
          await openAtlasCart();
        } catch (err) {
          if (errorBox) { errorBox.textContent = err.message; errorBox.hidden = false; } else toast(err.message);
        } finally {
          if (btn) { btn.classList.remove('nk-loading'); btn.removeAttribute('aria-disabled'); }
        }
      });
    });
  }
  function buildItems(form) {
    const fd = new FormData(form);
    const properties = {};
    for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m && v !== '') properties[m[1]] = v; }
    const breakSelects = form._breakVariantIds ? form._breakVariantIds() : null;
    if (breakSelects && breakSelects.length) {
      const counts = {};
      breakSelects.forEach((id) => { counts[id] = (counts[id] || 0) + 1; });
      return Object.keys(counts).map((id) => ({ id: parseInt(id, 10), quantity: counts[id], properties }));
    }
    const extra = $$('[data-nk-addon]:checked', form.closest('[data-nk-product-root]') || form).map((c) => ({ id: parseInt(c.value, 10), quantity: 1 }));
    return [{ id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10), properties }, ...extra];
  }

  /* ---------- Variant picker ---------- */
  function initVariantPickers(root) {
    $$('[data-nk-variant-picker]', root).forEach((picker) => {
      if (picker._init) return; picker._init = true;
      const productRoot = picker.closest('[data-nk-product-root]');
      const dataEl = productRoot && productRoot.querySelector('[data-nk-product-json]');
      if (!dataEl) return;
      const product = JSON.parse(dataEl.textContent);
      productRoot._product = product;
      const update = () => {
        const selected = $$('[data-nk-option-index]', picker).map((el) => {
          if (el.tagName === 'SELECT') return el.value;
          const c = el.querySelector('input:checked'); return c ? c.value : null;
        });
        $$('[data-nk-option-index]', picker).forEach((el) => {
          const lbl = el.querySelector('[data-nk-selected-value]'); const idx = parseInt(el.dataset.nkOptionIndex, 10);
          if (lbl) lbl.textContent = selected[idx] || '';
        });
        const variant = product.variants.find((v) => v.options.every((o, i) => o === selected[i]));
        markAvailability(picker, product, selected);
        applyVariant(productRoot, product, variant);
      };
      picker.addEventListener('change', update);
      productRoot._updateVariant = update;
    });
  }
  function markAvailability(picker, product, selected) {
    $$('[data-nk-option-index]', picker).forEach((el) => {
      const idx = parseInt(el.dataset.nkOptionIndex, 10);
      $$('input, option', el).forEach((inp) => {
        const val = inp.value;
        const ok = product.variants.some((v) => v.available && v.options[idx] === val && v.options.every((o, i) => i === idx || i > idx || o === selected[i]));
        inp.classList.toggle('nk-is-unavailable', !ok);
      });
    });
  }
  function applyVariant(root, product, variant) {
    const strings = T.strings;
    const idInputs = $$('input[name="id"], select[name="id"]', root);
    $$('[data-nk-add-button]', root).forEach((btn) => {
      const label = btn.querySelector('[data-nk-add-label]') || btn;
      if (!variant) { btn.disabled = true; label.textContent = strings.unavailable; return; }
      btn.disabled = !variant.available;
      label.textContent = variant.available ? (btn.dataset.nkLabel || strings.addToCart) : strings.soldOut;
    });
    if (!variant) return;
    idInputs.forEach((i) => { i.value = variant.id; i.dispatchEvent(new Event('variant:set')); });
    // prices
    $$('[data-nk-price]', root).forEach((p) => {
      const cur = p.querySelector('[data-nk-price-current]'); const cmp = p.querySelector('[data-nk-price-compare]'); const save = p.querySelector('[data-nk-price-save]');
      if (cur) cur.textContent = formatMoney(variant.price);
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (cmp) { cmp.textContent = onSale ? formatMoney(variant.compare_at_price) : ''; cmp.hidden = !onSale; }
      if (save) {
        save.hidden = !onSale;
        if (onSale) {
          const pct = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
          save.textContent = (save.dataset.nkTemplate || 'SAVE [percentage]').replace('[percentage]', pct + '%').replace('[amount]', formatMoney(variant.compare_at_price - variant.price));
        }
      }
    });
    $$('[data-nk-in-button-price]', root).forEach((el) => { el.textContent = formatMoney(variant.price); });
    $$('[data-nk-sku]', root).forEach((el) => { el.textContent = variant.sku || ''; });
    // media
    if (variant.featured_media && root._gallery) root._gallery.goToMedia(variant.featured_media.id);
    // url
    if (root.hasAttribute('data-nk-update-url') && window.history.replaceState) {
      const url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
    // sticky / breaks
    $$('[data-nk-sticky-variant]').forEach((s) => { if (s.value != variant.id) s.value = variant.id; });
    root.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true, detail: { variant, product } }));
  }

  /* ---------- Quantity inputs ---------- */
  function initQty(root) {
    $$('[data-nk-qty-input]', root).forEach((wrap) => {
      if (wrap._init) return; wrap._init = true;
      const input = wrap.querySelector('input');
      wrap.addEventListener('click', (e) => {
        const b = e.target.closest('[data-nk-step]'); if (!b) return;
        e.preventDefault();
        const min = parseInt(input.min || '1', 10);
        input.value = Math.max(min, (parseInt(input.value, 10) || min) + parseInt(b.dataset.nkStep, 10));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ---------- Quantity breaks ---------- */
  function initBreaks(root) {
    $$('[data-nk-qty-breaks]', root).forEach((wrap) => {
      if (wrap._init) return; wrap._init = true;
      const productRoot = wrap.closest('[data-nk-product-root]');
      const form = productRoot && productRoot.querySelector('form[data-nk-product-form]');
      if (!form) return;
      const qtyInput = form.elements.namedItem('quantity');
      const useSelectors = wrap.hasAttribute('data-nk-variant-selectors');
      const sync = () => {
        const checked = wrap.querySelector('input[type="radio"]:checked'); if (!checked) return;
        const q = parseInt(checked.value, 10) || 1;
        if (qtyInput) qtyInput.value = q;
        $$('[data-nk-qty-input] input', productRoot).forEach((i) => { i.value = q; });
        form._multi = useSelectors && q > 0 && checked.closest('.nk-qty-break').querySelector('[data-nk-break-variant]') != null;
      };
      form._breakVariantIds = () => {
        if (!useSelectors) return null;
        const checked = wrap.querySelector('input[type="radio"]:checked'); if (!checked) return null;
        const sels = $$('[data-nk-break-variant]', checked.closest('.nk-qty-break'));
        return sels.length ? sels.map((s) => s.value) : null;
      };
      wrap.addEventListener('change', sync);
      const renderPrices = (variant) => {
        if (!variant) return;
        $$('.nk-qty-break', wrap).forEach((b) => {
          const q = parseInt(b.dataset.nkQty, 10) || 1; const pct = parseFloat(b.dataset.nkPct || '0'); const fixed = parseFloat(b.dataset.nkFixed || '0') * 100;
          const total = Math.max(0, Math.round(variant.price * q * (1 - pct / 100) - fixed));
          const cmpBase = (b.dataset.nkCompareSrc === 'price' || !variant.compare_at_price || variant.compare_at_price < variant.price) ? variant.price : variant.compare_at_price;
          const compare = cmpBase * q;
          const saved = Math.max(0, compare - total);
          const rep = (s) => (s || '').replace(/\[quantity\]/g, q).replace(/\[price\]/g, formatMoney(total)).replace(/\[compare_price\]/g, formatMoney(compare)).replace(/\[amount_saved\]/g, formatMoney(saved)).replace(/\[percentage_saved\]/g, compare ? Math.round(saved * 100 / compare) + '%' : '0%').replace(/\[unit_price\]/g, formatMoney(Math.round(total / q)));
          $$('[data-nk-tpl]', b).forEach((el) => {
            const out = rep(el.getAttribute('data-nk-tpl'));
            el.innerHTML = out;
            if (el.hasAttribute('data-nk-hide-if-nosave')) el.hidden = saved <= 0;
          });
          $$('[data-nk-break-variant]', b).forEach((s) => { if (!s._touched) s.value = variant.id; });
        });
      };
      $$('[data-nk-break-variant]', wrap).forEach((s) => s.addEventListener('change', () => { s._touched = true; }));
      productRoot.addEventListener('variant:changed', (e) => renderPrices(e.detail.variant));
      const dataEl = productRoot.querySelector('[data-nk-product-json]');
      if (dataEl) {
        const product = JSON.parse(dataEl.textContent);
        const curId = parseInt((form.querySelector('[name="id"]') || {}).value, 10);
        renderPrices(product.variants.find((v) => v.id === curId) || product.variants[0]);
      }
      sync();
    });
  }

  /* ---------- Sticky ATC ---------- */
  function initStickyAtc(root) {
    $$('[data-nk-sticky-atc]', root).forEach((bar) => {
      if (bar._init) return; bar._init = true;
      const productRoot = document.querySelector(`[data-nk-product-root][data-nk-section="${bar.dataset.nkSection}"]`);
      if (!productRoot) return;
      const mainBtn = productRoot.querySelector('[data-nk-add-button]');
      const mode = bar.dataset.nkDisplay;
      const show = (v) => bar.classList.toggle('nk-is-visible', v);
      if (mode === 'always') show(true);
      else if (mainBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(([en]) => show(!en.isIntersecting && en.boundingClientRect.top < 0)).observe(mainBtn);
      }
      const sel = bar.querySelector('[data-nk-sticky-variant]');
      if (sel) sel.addEventListener('change', () => {
        const product = productRoot._product; if (!product) return;
        const v = product.variants.find((x) => x.id == sel.value); if (!v) return;
        // set options on main picker
        const picker = productRoot.querySelector('[data-nk-variant-picker]');
        if (picker) {
          $$('[data-nk-option-index]', picker).forEach((el) => {
            const idx = parseInt(el.dataset.nkOptionIndex, 10); const val = v.options[idx];
            if (el.tagName === 'SELECT') el.value = val; else { const r = $$('input', el).find((i) => i.value === val); if (r) r.checked = true; }
          });
          if (productRoot._updateVariant) productRoot._updateVariant();
        } else applyVariant(productRoot, product, v);
      });
      const btn = bar.querySelector('[data-nk-sticky-btn]');
      if (btn) btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (bar.dataset.nkFunction === 'scroll') { productRoot.scrollIntoView({ behavior: 'smooth' }); return; }
        const form = productRoot.querySelector('form[data-nk-product-form]');
        if (form) { const main = productRoot.querySelector('[data-nk-add-button]'); if (form.requestSubmit) form.requestSubmit(main || undefined); else form.submit(); }
      });
    });
  }

  /* ---------- Slider ---------- */
  function initSliders(root) {
    $$('[data-nk-slider]', root).forEach((wrap) => {
      if (wrap._init) return; wrap._init = true;
      const track = wrap.querySelector('.nk-slider'); if (!track) return;
      const prev = wrap.querySelector('[data-nk-slider-prev]'); const next = wrap.querySelector('[data-nk-slider-next]');
      const dotsWrap = wrap.querySelector('[data-nk-slider-dots]');
      const slides = () => Array.from(track.children).filter((c) => c.offsetParent !== null || c.getClientRects().length);
      const step = () => { const s = slides(); return s.length > 1 ? s[1].offsetLeft - s[0].offsetLeft : track.clientWidth; };
      const loop = wrap.dataset.nkLoop === 'true';
      const go = (dir) => {
        const max = track.scrollWidth - track.clientWidth - 4;
        if (loop && dir > 0 && track.scrollLeft >= max) track.scrollTo({ left: 0 });
        else if (loop && dir < 0 && track.scrollLeft <= 4) track.scrollTo({ left: track.scrollWidth });
        else track.scrollBy({ left: dir * step() });
      };
      if (prev) prev.addEventListener('click', () => go(-1));
      if (next) next.addEventListener('click', () => go(1));
      const buildDots = () => {
        if (!dotsWrap) return;
        const pages = Math.max(1, Math.round(track.scrollWidth / Math.max(1, step())) - Math.round(track.clientWidth / Math.max(1, step())) + 1);
        dotsWrap.innerHTML = '';
        if (pages <= 1) return;
        for (let i = 0; i < pages; i++) {
          const b = document.createElement('button'); b.type = 'button'; b.className = 'nk-slider-dot'; b.setAttribute('aria-label', `Slide ${i + 1}`);
          b.addEventListener('click', () => track.scrollTo({ left: i * step() })); dotsWrap.appendChild(b);
        }
      };
      const updateUI = () => {
        const max = track.scrollWidth - track.clientWidth - 4;
        if (!loop) { if (prev) prev.disabled = track.scrollLeft <= 4; if (next) next.disabled = track.scrollLeft >= max; }
        const nav = wrap.querySelector('.nk-slider-nav'); if (nav) nav.hidden = track.scrollWidth <= track.clientWidth + 4;
        if (dotsWrap) { const i = Math.round(track.scrollLeft / Math.max(1, step())); $$('.nk-slider-dot', dotsWrap).forEach((d, j) => d.setAttribute('aria-current', j === i)); }
        wrap.dispatchEvent(new CustomEvent('slider:scroll', { detail: { index: Math.round(track.scrollLeft / Math.max(1, step())) } }));
      };
      track.addEventListener('scroll', debounce(updateUI, 60));
      window.addEventListener('resize', debounce(() => { buildDots(); updateUI(); }, 200));
      buildDots(); updateUI();
      const speed = parseFloat(wrap.dataset.nkAutoplay || '0');
      if (speed > 0) {
        let paused = false;
        wrap.addEventListener('mouseenter', () => { paused = true; }); wrap.addEventListener('mouseleave', () => { paused = false; });
        setInterval(() => { if (!paused && !document.hidden) { const max = track.scrollWidth - track.clientWidth - 4; if (track.scrollLeft >= max) track.scrollTo({ left: 0 }); else track.scrollBy({ left: step() }); } }, speed * 1000);
      }
      wrap._goTo = (i) => track.scrollTo({ left: i * step() });
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery(root) {
    $$('[data-nk-gallery]', root).forEach((g) => {
      if (g._init) return; g._init = true;
      const productRoot = g.closest('[data-nk-product-root]');
      const track = g.querySelector('.nk-slider');
      const thumbs = $$('[data-nk-thumb]', g);
      const slidesAll = () => $$('[data-nk-media-id]', track);
      const goTo = (i) => {
        const s = slidesAll()[i]; if (!s) return;
        if (g.classList.contains('nk-gallery--grid') && window.innerWidth >= 990) { s.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        else track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        thumbs.forEach((t, j) => t.setAttribute('aria-current', j === i));
        const t = thumbs[i]; if (t) t.parentElement.scrollTo({ left: t.offsetLeft - t.parentElement.clientWidth / 2 + t.clientWidth / 2, top: t.offsetTop - t.parentElement.clientHeight / 2, behavior: 'smooth' });
      };
      thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));
      track.addEventListener('scroll', debounce(() => {
        const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        thumbs.forEach((t, j) => t.setAttribute('aria-current', j === i));
        $$('video', track).forEach((v, j) => { if (!v.closest('[data-nk-media-id]') || slidesAll().indexOf(v.closest('[data-nk-media-id]')) !== i) { if (!v.hasAttribute('data-nk-keep-playing')) v.pause(); } });
      }, 80));
      if (productRoot) productRoot._gallery = {
        goToMedia: (id) => {
          const idx = slidesAll().findIndex((s) => s.dataset.nkMediaId == id);
          if (idx < 0) return;
          if (g.dataset.nkPrepend === 'true' && idx > 0) { const s = slidesAll()[idx]; track.prepend(s); const th = thumbs[idx]; if (th) th.parentElement.prepend(th); thumbs.splice(0, 0, thumbs.splice(idx, 1)[0]); goTo(0); }
          else goTo(idx);
        }
      };
    });
  }

  /* ---------- Copy buttons ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-nk-copy]'); if (!b) return;
    e.preventDefault();
    const val = b.getAttribute('data-nk-copy');
    const done = () => { b.classList.add('nk-is-copied'); const o = b.dataset.nkLabel || b.textContent; b.dataset.nkLabel = o; b.textContent = T.strings.copied; toast(`${val} — ${T.strings.copied}`); setTimeout(() => { b.textContent = o; b.classList.remove('nk-is-copied'); }, 2000); };
    if (navigator.clipboard) navigator.clipboard.writeText(val).then(done, done); else done();
  });

  /* ---------- Countdowns ---------- */
  function initCountdowns(root) {
    $$('[data-nk-countdown]', root).forEach((el) => {
      if (el._init) return; el._init = true;
      let end;
      if (el.dataset.nkEnd) end = new Date(el.dataset.nkEnd).getTime();
      else {
        const mins = parseInt(el.dataset.nkEvergreen || '0', 10);
        if (el.dataset.nkDaily === 'true') { const d = new Date(); d.setHours(23, 59, 59, 999); end = d.getTime(); }
        else if (mins) {
          const key = 'nk-cd-' + (el.dataset.nkKey || 'x');
          try { end = parseInt(localStorage.getItem(key) || '0', 10); } catch (e) { end = 0; }
          if (!end || end < Date.now()) { end = Date.now() + mins * 60000; try { localStorage.setItem(key, end); } catch (e) { /* ignore */ } }
        }
      }
      if (!end || isNaN(end)) return;
      const parts = { d: el.querySelector('[data-nk-d]'), h: el.querySelector('[data-nk-h]'), m: el.querySelector('[data-nk-m]'), s: el.querySelector('[data-nk-s]') };
      const tick = () => {
        let diff = Math.max(0, end - Date.now());
        const d = Math.floor(diff / 864e5); diff -= d * 864e5;
        const h = Math.floor(diff / 36e5); diff -= h * 36e5;
        const m = Math.floor(diff / 6e4); diff -= m * 6e4;
        const s = Math.floor(diff / 1e3);
        const pad = (n) => String(n).padStart(2, '0');
        if (parts.d) parts.d.textContent = pad(d); if (parts.h) parts.h.textContent = pad(h); if (parts.m) parts.m.textContent = pad(m); if (parts.s) parts.s.textContent = pad(s);
        if (end - Date.now() <= 0) { clearInterval(el._iv); if (el.dataset.nkHideOnEnd === 'true') (el.closest('[data-nk-countdown-wrap]') || el).hidden = true; }
      };
      tick(); el._iv = setInterval(tick, 1000);
    });
  }

  /* ---------- Shipping dates ---------- */
  function initShippingDates(root) {
    $$('[data-nk-ship-date]', root).forEach((el) => {
      if (el._init) return; el._init = true;
      const days = (el.dataset.nkDays || 'Mon,Tue,Wed,Thu,Fri,Sat,Sun').split(',').map((s) => s.trim());
      const months = (el.dataset.nkMonths || 'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec').split(',').map((s) => s.trim());
      const fmt = el.dataset.nkFormat || 'dd_mm';
      const skipWeekends = el.dataset.nkSkipWeekends === 'true';
      const add = (n) => {
        const d = new Date(); let added = 0;
        while (added < n) { d.setDate(d.getDate() + 1); if (!skipWeekends || (d.getDay() !== 0 && d.getDay() !== 6)) added++; }
        return d;
      };
      const out = (d) => {
        const wd = days[(d.getDay() + 6) % 7]; const mo = months[d.getMonth()]; const dd = d.getDate();
        switch (fmt) {
          case 'mm_dd': return `${mo} ${dd}`;
          case 'day_dd_mm': return `${wd}, ${dd} ${mo}`;
          case 'day_mm_dd': return `${wd}, ${mo} ${dd}`;
          default: return `${dd} ${mo}`;
        }
      };
      const min = parseInt(el.dataset.nkMin || '0', 10); const max = parseInt(el.dataset.nkMax || '0', 10);
      el.innerHTML = (el.dataset.nkTpl || '[start_date] - [end_date]').replace('[start_date]', out(add(min))).replace('[end_date]', out(add(max)));
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal(root) {
    if (!T.animations || !('IntersectionObserver' in window) || document.documentElement.classList.contains('shopify-design-mode')) { $$('.nk-reveal-on-scroll', root).forEach((el) => el.classList.add('nk-is-revealed')); return; }
    const io = new IntersectionObserver((ens) => ens.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('nk-is-revealed'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -60px 0px' });
    $$('.nk-reveal-on-scroll:not(.nk-is-revealed)', root).forEach((el) => io.observe(el));
  }

  /* ---------- Counters ---------- */
  function initCounters(root) {
    const els = $$('[data-nk-count-to]', root).filter((e) => !e._init);
    if (!els.length) return;
    const run = (el) => {
      el._init = true;
      const to = parseFloat(el.dataset.nkCountTo); const dur = parseInt(el.dataset.nkDuration || '1800', 10); const dec = (String(to).split('.')[1] || '').length;
      const t0 = performance.now();
      const f = (t) => { const p = Math.min(1, (t - t0) / dur); const e = 1 - Math.pow(1 - p, 3); el.textContent = (to * e).toFixed(dec); if (p < 1) requestAnimationFrame(f); };
      requestAnimationFrame(f);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    const io = new IntersectionObserver((ens) => ens.forEach((en) => { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } }), { threshold: .4 });
    els.forEach((el) => io.observe(el));
    $$('[data-nk-bar-to]', root).forEach((bar) => {
      const io2 = new IntersectionObserver(([en]) => { if (en.isIntersecting) { bar.style.width = bar.dataset.nkBarTo + '%'; io2.disconnect(); } }, { threshold: .3 });
      io2.observe(bar);
    });
  }

  /* ---------- Before / after ---------- */
  function initCompare(root) {
    $$('[data-nk-compare]', root).forEach((el) => {
      if (el._init) return; el._init = true;
      const range = el.querySelector('input[type="range"]');
      const set = () => el.style.setProperty('--pos', range.value + '%');
      range.addEventListener('input', set); set();
    });
  }

  /* ---------- Tabs ---------- */
  function initTabs(root) {
    $$('[data-nk-tabs]', root).forEach((wrap) => {
      if (wrap._init) return; wrap._init = true;
      const tabs = $$('[role="tab"]', wrap);
      tabs.forEach((t) => t.addEventListener('click', () => {
        tabs.forEach((x) => { const on = x === t; x.setAttribute('aria-selected', on); const p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on; });
      }));
    });
  }

  /* ---------- Accordions (single-open) ---------- */
  function initAccordions(root) {
    $$('[data-nk-accordion-single]', root).forEach((wrap) => {
      if (wrap._init) return; wrap._init = true;
      $$('details', wrap).forEach((d) => d.addEventListener('toggle', () => { if (d.open) $$('details', wrap).forEach((o) => { if (o !== d) o.open = false; }); }));
    });
  }

  /* ---------- Videos ---------- */
  function initVideos(root) {
    $$('[data-nk-video]', root).forEach((w) => {
      if (w._init) return; w._init = true;
      const v = w.querySelector('video'); if (!v) return;
      const play = w.querySelector('[data-nk-video-play]'); const sound = w.querySelector('[data-nk-video-sound]');
      const sync = () => { w.classList.toggle('nk-is-playing', !v.paused); };
      if (play) play.addEventListener('click', (e) => { e.preventDefault(); if (v.paused) { v.play(); } else v.pause(); });
      if (sound) sound.addEventListener('click', (e) => { e.preventDefault(); v.muted = !v.muted; w.classList.toggle('nk-is-unmuted', !v.muted); if (!v.muted && v.paused) v.play(); });
      v.addEventListener('play', sync); v.addEventListener('pause', sync);
      if (v.hasAttribute('data-nk-autoplay') && 'IntersectionObserver' in window) {
        new IntersectionObserver(([en]) => { if (en.isIntersecting) v.play().catch(() => {}); else v.pause(); }, { threshold: .25 }).observe(v);
      }
    });
  }

  /* ---------- Announcement ---------- */
  function initAnnouncements(root) {
    $$('[data-nk-announcement]', root).forEach((bar) => {
      if (bar._init) return; bar._init = true;
      const slides = $$('.nk-announcement__slide', bar); if (slides.length < 2) return;
      let i = 0;
      const show = (n) => { i = (n + slides.length) % slides.length; slides.forEach((s, j) => s.classList.toggle('nk-is-active', j === i)); };
      const p = bar.querySelector('[data-nk-ann-prev]'); const n = bar.querySelector('[data-nk-ann-next]');
      if (p) p.addEventListener('click', () => show(i - 1)); if (n) n.addEventListener('click', () => show(i + 1));
      const sp = parseInt(bar.dataset.nkSpeed || '4', 10) * 1000; let paused = false;
      bar.addEventListener('mouseenter', () => { paused = true; }); bar.addEventListener('mouseleave', () => { paused = false; });
      if (bar.dataset.nkAutoplay !== 'false') setInterval(() => { if (!paused) show(i + 1); }, sp);
    });
  }

  /* ---------- Header ---------- */
  function initHeader() {
    const h = $('[data-nk-sticky-header]'); if (!h || h._init) return; h._init = true;
    const mode = h.dataset.nkStickyHeader;
    const section = h.closest('.shopify-section');
    if (mode === 'none' || !section) return;
    section.classList.add('nk-section-header-sticky');
    if (mode === 'on-scroll-up') {
      let last = 0;
      window.addEventListener('scroll', () => {
        const y = window.scrollY;
        if (y > last && y > 200) section.classList.add('nk-is-hidden'); else section.classList.remove('nk-is-hidden');
        last = y;
      }, { passive: true });
    }
    $$('[data-nk-hover-menu] > details', h).forEach((d) => {
      const li = d.parentElement;
      li.addEventListener('mouseenter', () => { if (window.matchMedia('(hover: hover)').matches) d.open = true; });
      li.addEventListener('mouseleave', () => { if (window.matchMedia('(hover: hover)').matches) d.open = false; });
    });
  }

  /* ---------- Search ---------- */
  function initSearch() {
    $$('[data-nk-search-toggle]').forEach((b) => b.addEventListener('click', (e) => {
      e.preventDefault(); const m = $('[data-nk-search-modal]'); if (!m) return;
      m.hidden = !m.hidden; if (!m.hidden) { const i = m.querySelector('input[type="search"]'); if (i) i.focus(); }
    }));
    $$('[data-nk-predictive-search]').forEach((form) => {
      const input = form.querySelector('input[type="search"]'); const out = form.parentElement.querySelector('[data-nk-predictive-results]');
      if (!input || !out) return;
      input.addEventListener('input', debounce(async () => {
        const q = input.value.trim(); if (!q) { out.innerHTML = ''; return; }
        try {
          const r = await fetch(`${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[limit]=6&resources[type]=product,collection,page,article`);
          const html = await r.text(); const doc = new DOMParser().parseFromString(html, 'text/html');
          const res = doc.querySelector('[data-nk-predictive-inner]'); out.innerHTML = res ? res.innerHTML : '';
        } catch (e) { out.innerHTML = ''; }
      }, 300));
    });
    $$('[data-nk-search-close]').forEach((b) => b.addEventListener('click', () => { const m = $('[data-nk-search-modal]'); if (m) m.hidden = true; }));
  }

  /* ---------- Facets ---------- */
  function initFacets(root) {
    $$('[data-nk-facets-form]', root).forEach((form) => {
      if (form._init) return; form._init = true;
      form.addEventListener('change', debounce(() => {
        const params = new URLSearchParams(new FormData(form));
        for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
        window.location.search = params.toString();
      }, 500));
    });
  }

  /* ---------- Popup ---------- */
  function initPopups(root) {
    $$('[data-nk-popup]', root).forEach((m) => {
      if (m._init) return; m._init = true;
      const key = 'nk-popup-' + m.dataset.nkPopup; const days = parseFloat(m.dataset.nkDays || '1');
      let seen = 0; try { seen = parseInt(localStorage.getItem(key) || '0', 10); } catch (e) { /* ignore */ }
      if (window.Shopify && Shopify.designMode && m.dataset.nkPreview === 'true') { m.classList.add('nk-is-open'); return; }
      if (seen && Date.now() - seen < days * 864e5) return;
      const show = () => { m.classList.add('nk-is-open'); try { localStorage.setItem(key, Date.now()); } catch (e) { /* ignore */ } };
      const trigger = m.dataset.nkTrigger;
      if (trigger === 'exit') document.addEventListener('mouseout', function h(e) { if (!e.relatedTarget && e.clientY < 10) { show(); document.removeEventListener('mouseout', h); } });
      else setTimeout(show, parseInt(m.dataset.nkDelay || '5', 10) * 1000);
      m.addEventListener('click', (e) => { if (e.target.closest('[data-nk-popup-close]') || e.target.classList.contains('nk-modal__overlay')) m.classList.remove('nk-is-open'); });
    });
    $$('.nk-modal:not([data-nk-popup])', root).forEach((m) => {
      if (m._init) return; m._init = true;
      m.addEventListener('click', (e) => { if (e.target.classList.contains('nk-modal__overlay') || e.target.closest('[data-nk-modal-close]')) { m.classList.remove('nk-is-open'); if (!$('.nk-drawer.is-open, .nk-modal.is-open')) document.body.style.overflow = ''; } });
    });
  }

  /* ---------- Misc ---------- */
  function initScrollTop() {
    const b = $('[data-nk-scroll-top]'); if (!b || b._init) return; b._init = true;
    window.addEventListener('scroll', () => { b.hidden = window.scrollY < 600; }, { passive: true });
    b.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }
  function initLocalization(root) {
    $$('[data-nk-localization] select', root).forEach((s) => { if (s._init) return; s._init = true; s.addEventListener('change', () => s.form.submit()); });
  }
  function initScrollLinks(root) {
    $$('[data-nk-scroll-to]', root).forEach((a) => {
      if (a._init) return; a._init = true;
      a.addEventListener('click', (e) => { const t = document.getElementById(a.dataset.nkScrollTo); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); } });
    });
  }

  function initAll(root = document) {
    initCartControls(root); initProductForms(root); initVariantPickers(root); initQty(root); initBreaks(root); initStickyAtc(root);
    initSliders(root); initGallery(root); initCountdowns(root); initShippingDates(root); initReveal(root); initCounters(root);
    initCompare(root); initTabs(root); initAccordions(root); initVideos(root); initAnnouncements(root); initFacets(root);
    initPopups(root); initLocalization(root); initScrollLinks(root);
  }
  T.initAll = initAll; window.nkTheme = T;

  const boot = () => { initAll(document); initHeader(); initSearch(); initScrollTop(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('shopify:section:load', (e) => { initAll(e.target); if (e.target.querySelector('[data-nk-sticky-header]')) initHeader(); });
  document.addEventListener('shopify:block:select', (e) => {
    const slide = e.target.closest('.nk-slider > *'); const wrap = e.target.closest('[data-nk-slider]');
    if (slide && wrap && wrap._goTo) wrap._goTo(Array.from(slide.parentElement.children).indexOf(slide));
    const ann = e.target.closest('.nk-announcement__slide'); if (ann) { $$('.nk-announcement__slide', ann.parentElement).forEach((s) => s.classList.toggle('nk-is-active', s === ann)); }
  });
})();